import React, { useState } from 'react';
import { Container, Paper, InputBase, IconButton, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';

function SearchBar() {
    const [searchKey, setSearchKey] = useState<string>('');
    const navigate = useNavigate();

    const handleSearch = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        if (searchKey) navigate(`/search?keyword=${searchKey}`);
    };

    return (
        <Box
            sx={{
                backgroundColor: { xs: 'white', md: '#EDEDED' },
                padding: { xs: '0px 0px 20px 0px', md: '24px 0rem' },
                width: '100%',
                position: { xs: 'static', md: 'absolute' },
                top: { xs: '50px', md: '150px' },
                zIndex: '9999'
            }}
        >
            <Container>
                <Paper
                    component="form"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: { xs: 'white', md: '#FFFFFF' },
                        border: '1px solid #D6D6D6',
                        borderRadius: '4px'
                    }}
                >
                    <InputBase
                        id="search"
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search by Keyword or Application Type"
                        inputProps={{ 'aria-label': 'search' }}
                        value={searchKey}
                        onChange={(e) => setSearchKey(e.currentTarget.value)}
                        autoFocus
                    />
                    <IconButton type="submit" sx={{ p: '10px' }} aria-label="search" onClick={handleSearch}>
                        <SearchIcon />
                    </IconButton>
                </Paper>
            </Container>
        </Box>
    );
}

export default SearchBar;
